"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoViewMode = void 0;
var VideoViewMode;
(function (VideoViewMode) {
    VideoViewMode["REGULAR"] = "REGULAR";
    VideoViewMode["BLUR"] = "BLUR";
    VideoViewMode["FILL"] = "FILL";
})(VideoViewMode || (VideoViewMode = {}));
exports.VideoViewMode = VideoViewMode;
//# sourceMappingURL=types.js.map